import React, { Fragment } from 'react'

const Apropos = () => {
  return (
    <Fragment>
        <div className="content2">
        <div className="container-fluid">
        <div className="row">
        <div className=" account-content">
        <div className="col-lg-10" style={{'textAlign': 'justify', 'lineHeight':1.8, 'margin':'auto'}}>
        <h1>À PROPOS</h1>

                Syidocs est une solution d’archivage numérique pensée pour sécuriser, organiser et valoriser 
                les documents sensibles (diplômes, certificats, cartes professionnelles, contrats, etc.) dans un environnement fiable et adapté aux réalités locales.
                <br/><br/>

               <h4>Objectifs</h4>
Centraliser les archives dans une plateforme unique.

Garantir la traçabilité grâce aux métadonnées et aux règles de conservation.

Sécuriser les documents avec des niveaux de confidentialité adaptés.

Simplifier l’accès aux archives pour les agents et les usagers.

Optimiser la durée de conservation selon les obligations légales et les besoins métiers.
                <br/><br/>
               <h4> Fonctionnalités clés</h4>

              
Profils d’archives dynamiques : champs personnalisables pour chaque type de document.

Import Zip/csv : gestion en masse des métadonnées et des fichiers.

Règles de conservation : durée, confidentialité, sort final.

Traçabilité : journal des accès et empreinte numérique (hash).

Interface intuitive : recherche rapide, filtres par type, date, titulaire.
               
                <br/><br/>
               <h4>Valeur ajoutée</h4>

               
Souplesse : profils et règles adaptables aux besoins des institutions.

Simplicité : interface claire pour agents et utilisateurs.

Sécurité : confidentialité et intégrité garanties.

Durabilité : conservation conforme aux normes archivistiques.


        </div>
        </div>
        </div>
        </div>
        </div>
    </Fragment>
  )
}

export default Apropos
